<label class="mb-2">{{ title() | translate }}</label>

<app-form-array-table
  [formArray]="formControls()"
  [canAdd]="canAdd()"
  (add)="createNewFileGroup.emit()"
>
  <ng-template #headers>
    <th class="col-input">
      {{ translationKey + "investedAmount" | translate }}
    </th>
    <th class="col-input">
      {{ translationKey + "annualInterestCommitment" | translate }}
    </th>
    <th class="col-input">
      {{ translationKey + "totalInterest" | translate }}
    </th>
    <th class="col-action"></th>
  </ng-template>

  <ng-template #row let-formGroup let-index="index">
    <ng-container [formGroup]="formGroup" (ngSubmit)="onFormSubmit($event)">
      <td class="col-input">
        <app-validated-number-input
          [label]="''"
          inputFormControlName="investedAmount"
          [inputFormControl]="formGroup.controls.investedAmount"
          (keydown.enter)="onEnterKey($event)"
        />
      </td>
      <td class="col-input">
        <app-validated-number-input
          [label]="''"
          inputFormControlName="annualInterestCommitment"
          [inputFormControl]="formGroup.controls.annualInterestCommitment"
          (keydown.enter)="onEnterKey($event)"
        />
      </td>
      <td class="col-input">
        <app-validated-number-input
          [label]="''"
          inputFormControlName="totalInterest"
          [inputFormControl]="formGroup.controls.totalInterest"
          (keydown.enter)="onEnterKey($event)"
        />
      </td>
      <td class="col-action">
        <div class="action" (click)="rowRemoveClicked.emit(index)">
          <span class="far fa-trash-alt text-primary"></span>
        </div>
      </td>
    </ng-container>
  </ng-template>
</app-form-array-table>
